import {
    EditListPopup,
    PopupComponent,
    PopupElements
} from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { initCompanyPerson } from './main';
import SearchFilter from './search-filter';
import { SortingList } from './sorting-list';

export default class CompanyPerson {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: document.querySelector('[data-action="AddPerson"]'),
            editButtons: Array.from(
                document.querySelectorAll('[data-action="EditPerson"]')
            ),
            deleteButtons: []
        };

        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerPersonForm',
            removeItemUrl: null,
            addItemUrlParameters: [],
            editItemUrlParameters: [
                {
                    fieldName: 'personId',
                    dataAttributeTargetValue: 'data-person-id'
                }
            ],
            removeItemUrlParameters: []
        };

        new EditListPopup().init(
            'PersonForm',
            'person-form-popup',
            popupElements,
            popupComponent,
            () => this.reloadComponent()
        );

        const component = document.querySelector(
            '[data-component=CustomerCompanyPersons]'
        );
        const filter = new SearchFilter(component, initCompanyPerson);
        new SortingList(component, initCompanyPerson, [], filter);
    }

    private reloadComponent(): void {
        const action = new ActionCreator().reloadComponent(
            'CustomerCompanyPersons'
        );
        action.successAction = () => initCompanyPerson();

        new AjaxDispatcher().dispatchGetAction(action);
    }
}
